import { Helmet } from 'react-helmet-async';
import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import { submitInquiry } from '../../services/api';
import { companyDetails } from '../../data/siteData';

var bnrimg = require('./../../images/banner/9.jpg');


class ContactUs extends React.Component {
    state = {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        submitting: false,
        submitted: false,
        feedbackMsg: ''
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        if (this.state.submitting) return;
        this.setState({ submitting: true, feedbackMsg: '' });
        
        const res = await submitInquiry({
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            subject: this.state.subject,
            message: this.state.message
        });

        if (res && res.success) {
            this.setState({
                submitted: true,
                submitting: false,
                feedbackMsg: res.message || 'Thank you! Your inquiry has been sent to bs clads.',
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            });
            setTimeout(() => {
                this.setState({ submitted: false, feedbackMsg: '' });
            }, 6000);
        } else {
            this.setState({
                submitted: true,
                submitting: false,
                feedbackMsg: res.message || 'Thank you! Your message has been recorded.'
            });
        }
    };

    render() {

        return (
            <>
                <Helmet>
                    <title>bs clads</title>
                    <meta name="description" content="Get in touch with bs clads for expert ACP Front Elevation, Facade Glazing and Toughened Glass inquiries. Call us or drop a message." />
                </Helmet>
                <Header />
                <div className="page-content">
                    <Banner 
                        title={`Get in Touch with ${companyDetails.name}`} 
                        pagename="Contact Us" 
                        description="Get in touch with bs clads for expert ACP Front Elevation, Facade Glazing and Toughened Glass inquiries." 
                        bgimage={bnrimg} 
                    />
                    
                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 bg-white">
                        <div className="container">
                            <div className="section-content">
                                <div className="row justify-content-center">
                                    {/* CONTACT FORM */}
                                    <div className="col-lg-7 col-md-12 col-sm-12 m-b30">
                                        <div className="contact-form-box bg-gray" style={{
                                            borderRadius: '12px',
                                            boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
                                            border: '1px solid #e9e9e9',
                                            padding: '30px'
                                        }}>
                                            <div className="section-head text-center m-b30">
                                                <div className="sx-separator-outer separator-center">
                                                    <div className="sx-separator bg-white">
                                                        <h3 className="sep-line-one text-center" style={{ whiteSpace: 'nowrap', fontSize: 'clamp(22px, 5.5vw, 30px)', fontWeight: '800', textAlign: 'center' }}>Send Us A Message</h3>
                                                    </div>
                                                </div>
                                            </div>

                                            {this.state.submitted && (
                                                <div className="alert alert-success m-b20 text-center" style={{ borderRadius: '8px', backgroundColor: '#009049', color: '#fff', fontWeight: '600', padding: '12px 18px' }}>
                                                    {this.state.feedbackMsg || 'Thank you! Your message has been sent to bs clads. We will contact you shortly.'}
                                                </div>
                                            )}

                                            <form className="contact-form" onSubmit={this.handleSubmit} style={{ width: '100%' }}>
                                                <div className="row">
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="form-group m-b20" style={{ width: '100%' }}>
                                                            <label style={{ fontWeight: '700', fontSize: '14px', color: '#222', marginBottom: '6px', display: 'block' }}>Full Name *</label>
                                                            <input
                                                                name="username"
                                                                type="text"
                                                                required
                                                                className="form-control"
                                                                placeholder="Your Name"
                                                                value={this.state.name}
                                                                onChange={(e) => this.setState({ name: e.target.value })}
                                                                style={{ borderRadius: '8px', height: '52px', border: '1px solid #ccc', padding: '12px 18px', fontSize: '14.5px', width: '100%', boxSizing: 'border-box' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="form-group m-b20" style={{ width: '100%' }}>
                                                            <label style={{ fontWeight: '700', fontSize: '14px', color: '#222', marginBottom: '6px', display: 'block' }}>Email Address *</label>
                                                            <input
                                                                name="email"
                                                                type="email"
                                                                className="form-control"
                                                                required
                                                                placeholder="your.email@example.com"
                                                                value={this.state.email}
                                                                onChange={(e) => this.setState({ email: e.target.value })}
                                                                style={{ borderRadius: '8px', height: '52px', border: '1px solid #ccc', padding: '12px 18px', fontSize: '14.5px', width: '100%', boxSizing: 'border-box' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="form-group m-b20" style={{ width: '100%' }}>
                                                            <label style={{ fontWeight: '700', fontSize: '14px', color: '#222', marginBottom: '6px', display: 'block' }}>Phone Number *</label>
                                                            <input
                                                                name="phone"
                                                                type="tel"
                                                                required
                                                                className="form-control"
                                                                placeholder="10-digit mobile number"
                                                                value={this.state.phone}
                                                                onChange={(e) => {
                                                                    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                                    this.setState({ phone: val });
                                                                }}
                                                                pattern="[0-9]{10}"
                                                                minLength={10}
                                                                maxLength={10}
                                                                title="Please enter a valid 10-digit mobile number"
                                                                style={{ borderRadius: '8px', height: '52px', border: `1px solid ${this.state.phone.length > 0 && this.state.phone.length < 10 ? '#e53935' : '#ccc'}`, padding: '12px 18px', fontSize: '14.5px', width: '100%', boxSizing: 'border-box' }}
                                                            />
                                                            {this.state.phone.length > 0 && this.state.phone.length < 10 && (
                                                                <small style={{ color: '#e53935', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                                                    ⚠ {10 - this.state.phone.length} more digit{10 - this.state.phone.length !== 1 ? 's' : ''} needed
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="form-group m-b20" style={{ width: '100%' }}>
                                                            <label style={{ fontWeight: '700', fontSize: '14px', color: '#222', marginBottom: '6px', display: 'block' }}>Service Interest *</label>
                                                            <input
                                                                name="subject"
                                                                type="text"
                                                                required
                                                                className="form-control"
                                                                placeholder="e.g. ACP Front Elevation, Facade Glazing..."
                                                                value={this.state.subject}
                                                                onChange={(e) => this.setState({ subject: e.target.value })}
                                                                style={{ borderRadius: '8px', height: '52px', border: '1px solid #ccc', padding: '12px 18px', fontSize: '14.5px', width: '100%', boxSizing: 'border-box' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group m-b25" style={{ width: '100%' }}>
                                                    <label style={{ fontWeight: '700', fontSize: '14px', color: '#222', marginBottom: '6px', display: 'block' }}>Your Message *</label>
                                                    <textarea
                                                        name="message"
                                                        rows={5}
                                                        className="form-control"
                                                        required
                                                        placeholder="How can we assist you with your project?"
                                                        value={this.state.message}
                                                        onChange={(e) => this.setState({ message: e.target.value })}
                                                        style={{ borderRadius: '8px', border: '1px solid #ccc', padding: '14px 18px', fontSize: '14.5px', width: '100%', boxSizing: 'border-box' }}
                                                    />
                                                </div>

                                                <div className="text-center m-t15" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                    <button
                                                        type="submit"
                                                        className="site-button btn-half"
                                                        disabled={this.state.submitting}
                                                        style={{
                                                            padding: '14px 45px',
                                                            borderRadius: '6px',
                                                            backgroundColor: this.state.submitting ? '#888888' : '#f03a02',
                                                            border: 'none',
                                                            margin: '0 auto',
                                                            cursor: this.state.submitting ? 'not-allowed' : 'pointer'
                                                        }}
                                                    >
                                                        <span>{this.state.submitting ? 'SENDING...' : 'SEND MESSAGE'}</span>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    {/* CONTACT INFO CARD */}
                                    <div className="col-lg-5 col-md-12 col-sm-12 m-b30">
                                        <div className="contact-info-card p-a25 text-white" style={{
                                            borderRadius: '16px',
                                            boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                                            height: 'fit-content',
                                            backgroundColor: '#161616',
                                            border: '1px solid rgba(255,255,255,0.08)'
                                        }}>
                                            <div>
                                                <div className="section-head m-b18" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px' }}>
                                                    <h3 className="text-white text-uppercase" style={{ letterSpacing: '1px', fontWeight: '800', margin: 0, whiteSpace: 'nowrap' }}>Contact Details</h3>
                                                    <p style={{ color: '#ffffff', fontWeight: '700', fontSize: '14px', marginTop: '4px', opacity: 0.9 }}>{companyDetails.name} ({companyDetails.tagline})</p>
                                                </div>

                                                {/* Contact Person */}
                                                <div className="d-flex align-items-start m-b15">
                                                    <div style={{
                                                        width: '42px',
                                                        height: '42px',
                                                        borderRadius: '10px',
                                                        backgroundColor: '#f03a02',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '14px',
                                                        flexShrink: 0,
                                                        boxShadow: '0 4px 12px rgba(240, 58, 2, 0.3)'
                                                    }}>
                                                        <i className="fa fa-user text-white" style={{ fontSize: '16px' }} />
                                                    </div>
                                                    <div>
                                                        <h5 className="m-t0 text-white" style={{ fontWeight: '700', fontSize: '16px', marginBottom: '3px' }}>{companyDetails.contactPerson}</h5>
                                                        <p style={{ color: '#ffffff', margin: 0, fontSize: '13.5px' }}>
                                                            Mobile: <a href={`tel:${companyDetails.phoneNumbers.primary}`} style={{ color: '#ffffff', fontWeight: '700', textDecoration: 'none' }}>{companyDetails.phoneNumbers.primary}</a>
                                                        </p>
                                                        <p style={{ color: '#dddddd', fontSize: '13px', marginTop: '2px' }}>
                                                            Email: <a href={`mailto:${companyDetails.email}`} style={{ color: '#ffffff', textDecoration: 'none' }}>{companyDetails.email}</a>
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Office Address */}
                                                <div className="d-flex align-items-start m-b15">
                                                    <div style={{
                                                        width: '42px',
                                                        height: '42px',
                                                        borderRadius: '10px',
                                                        backgroundColor: '#f03a02',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '14px',
                                                        flexShrink: 0,
                                                        boxShadow: '0 4px 12px rgba(240, 58, 2, 0.3)'
                                                    }}>
                                                        <i className="fa fa-building text-white" style={{ fontSize: '16px' }} />
                                                    </div>
                                                    <div>
                                                        <h5 className="m-t0 text-white" style={{ fontWeight: '700', fontSize: '16px', marginBottom: '3px' }}>Office Address</h5>
                                                        <p style={{ color: '#dddddd', margin: 0, fontSize: '13.5px', lineHeight: '1.5' }}>{companyDetails.officeAddress}</p>
                                                    </div>
                                                </div>

                                                {/* Factory Address */}
                                                <div className="d-flex align-items-start m-b15">
                                                    <div style={{
                                                        width: '42px',
                                                        height: '42px',
                                                        borderRadius: '10px',
                                                        backgroundColor: '#f03a02',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '14px',
                                                        flexShrink: 0,
                                                        boxShadow: '0 4px 12px rgba(240, 58, 2, 0.3)'
                                                    }}>
                                                        <i className="fa fa-industry text-white" style={{ fontSize: '16px' }} />
                                                    </div>
                                                    <div>
                                                        <h5 className="m-t0 text-white" style={{ fontWeight: '700', fontSize: '16px', marginBottom: '3px' }}>Factory Address</h5>
                                                        <p style={{ color: '#dddddd', margin: 0, fontSize: '13.5px', lineHeight: '1.5' }}>{companyDetails.factoryAddress}</p>
                                                    </div>
                                                </div>

                                                {/* Google Maps Directions Button */}
                                                <div className="m-t20">
                                                    <a
                                                        href={companyDetails.mapLink}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '10px',
                                                            backgroundColor: '#f03a02',
                                                            color: '#ffffff',
                                                            padding: '10px 20px',
                                                            borderRadius: '8px',
                                                            fontWeight: '700',
                                                            fontSize: '13.5px',
                                                            textDecoration: 'none',
                                                            boxShadow: '0 4px 14px rgba(240, 58, 2, 0.4)'
                                                        }}
                                                    >
                                                        <i className="fa fa-map-marker" style={{ fontSize: '16px' }} />
                                                        <span>Get Directions on Google Maps</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* MAP SECTION WITH GAP ABOVE FOOTER */}
                    <div className="gmap-outline" style={{ height: '400px', width: '100%', overflow: 'hidden', marginBottom: '35px', position: 'relative' }}>
                        <iframe
                            src="https://maps.google.com/maps?q=10.9980847,77.0148584&z=17&output=embed"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="bs clads Singanallur Coimbatore Location Map"
                        />
                    </div>
                </div>

                <Footer />
            </>
        );
    }
};

export default ContactUs;